import {
    DialogPositioningBehavior,
    DialogProps,
    DialogType,
    DialogWidget
  } from '@tableau/widgets';
  import React from 'react';

  import { Messages } from '~src/codegen/Localize';
  import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
  import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { KMSKeyGenerateView } from '../components/KMSKeyGenerateView';


export const openGenerateKMSKeyDialog = (isEncryptionEnabled: boolean = false, onCancel: () => void): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithTitleBar,
              title: Messages.extractEncryption_generateKMSKeyDialog_Title(),
              testId: 'generate-kms-key-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width600px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss, isEncryptionEnabled, onCancel);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, isEncryptionEnabled: boolean, onCancel: () => void) {
    // eslint-disable-next-line no-console
    console.log('getDialogWidget', isEncryptionEnabled);
    return (
      <DialogWidget {...dialogProps}>
        <KMSKeyGenerateView closeDialog={closeAndDismiss} isEncryptionEnabled={isEncryptionEnabled} onCancel={onCancel} />
      </DialogWidget>
    );
  }